// Imports
import React, { useState } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import {
  Grid,
  Paper,
  Typography,
  IconButton,
  Box,
  Divider,
  Link as Anchor,
  TextField,
  Button,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import './style.css';
import params from '../../../setup/config/params';
import { nullToEmptyString } from '../../../setup/helpers';
import { login } from '../api/actions/query';
import AuthCheck from '../../auth/AuthCheck';
import routes from '../api/routes';
import GoogleLoginButton from './GoogleLoginButton';
import { useGoogleClientId } from "../../../setup/config/GoogleProviderWrapper";

function Login({ login }) {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const googleClientId = useGoogleClientId();

  const onType = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const { email, password } = form;
    if (!isEmpty(email) && !isEmpty(password)) {
      login({ email, password });
    }
  };

  const { email, password } = form;
  const { isLoading } = auth;

  return (
    <div className="login-root">
      <Paper className="login-container">
        <Typography variant="subtitle1" color="inherit" className="login-heading">
          Login
        </Typography>

        { googleClientId && 
          <>
            <GoogleLoginButton dispatch={dispatch} />
            <Divider sx={{ my: 2, fontSize: '14px', color: '#9b9a9aff' }}> Or with email and password </Divider>
          </>
        }

        <form onSubmit={handleLogin}>
          <Grid item xs={12} sx={{ mb: 1.5 }}>
            <TextField
              name="email"
              type="email"
              value={nullToEmptyString(email)}
              onChange={onType}
              label="Email"
              placeholder="Enter email"
              required
              margin="dense"
              autoComplete="off"
              fullWidth
              autoFocus
              variant="standard"
            />
          </Grid>

          <Grid item xs={12} sx={{ mb: 1.5, position: 'relative' }}>
            <TextField
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={nullToEmptyString(password)}
              onChange={onType}
              label="Password"
              placeholder="Enter password"
              required
              margin="dense"
              autoComplete="off"
              fullWidth
              variant="standard"
            />
            <IconButton
              onClick={togglePasswordVisibility}
              edge="end"
              sx={{
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
                right: 0,
              }}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </Grid>

          <Grid item xs={12} className="login-buttons-container" sx={{ textAlign: 'center' }}>
            <Button
              type="submit"
              variant="contained"
              aria-label="Login"
              color="primary"
              disabled={isLoading}
            >
              Login
            </Button>
          </Grid>
        </form>
      </Paper>

      <Link to={routes.forgotPassword.path}>
        <Anchor component="span">Forgot Password</Anchor>
      </Link>
      <br />
      <Link to={routes.userSignup.path}>
        <Anchor component="span">
          Create account for {params.site.name} Store console - Signup
        </Anchor>
      </Link>

      <AuthCheck />

    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { login })(Login);
